import {
  SET_USER_EXPERIENCE_RANGE,
  SET_USER_STATE,
  SET_USER_CITY,
  SET_USER_COUNTRY,
  SET_USER_STATE_LIST,
  SET_USER_TOP_CITIES,
  SET_USER_EXPERIENCE_RANGE_CUSTOM,
  SET_USER_SALARY_RANGE,
  SET_COUNTRY_LIST,
  SET_EXPERIENCE_SALARY_DATA,
  SET_CITY_SALARY_DATA,
  SET_SALARY_RANGE_SKELETON,
  SET_SINGLE_EXPERIENCE_SKELETON,
  SET_CITES_RANGE_SKELETON,
  SET_SINGLE_CITY_SKELETON,
  SET_SALARY_RANGE_BY_CITIES,
  SET_CITIES_LIST,
  SET_SALARY_RANGE_SKELETON_BOX,
} from "../action/userLocation";
let initialState = {
  rangeSkeleton: false,
  singleExperienceSkeleton: false,
  citiesRangeSkeleton: false,
  singleCityLoading: false,
  salaryRangeSkeletonBox:false
};

export default function UserLocationReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case SET_USER_STATE:
      const stateData = action.payload;
      state.userState = stateData;
      return { ...state };
    case SET_USER_CITY:
      const cityData = action.payload;
      state.userCity = cityData;
      return { ...state };
    case SET_USER_COUNTRY:
      const countryData = action.payload;
      state.userCountry = countryData;
      return { ...state };
    case SET_USER_STATE_LIST:
      const stateListData = action.payload;
      state.userStateList = stateListData;
      return { ...state };
    case SET_USER_TOP_CITIES:
      const topCitiesData = action.payload;
      state.userTopCities = topCitiesData;
      return { ...state };
    case SET_USER_EXPERIENCE_RANGE:
      const experienceRangeData = action.payload;
      state.userExperienceRange = experienceRangeData;
      return { ...state };
    case SET_USER_EXPERIENCE_RANGE_CUSTOM:
      const customExperienceRangeData = action.payload;
      state.userExperienceRangeCustom = customExperienceRangeData;
      return { ...state };
    case SET_USER_SALARY_RANGE:
      const salaryRange = action.payload;
      state.userSalaryRange = salaryRange;
      return { ...state };
    case SET_COUNTRY_LIST:
      const countries = action.payload;
      state.countriesList = countries;
      return { ...state };
    case SET_EXPERIENCE_SALARY_DATA:
      state.experienceSalaryData = action.payload;
      return { ...state };
    case SET_CITY_SALARY_DATA:
      state.citySalaryData = action.payload;
      return { ...state };
    case SET_SALARY_RANGE_SKELETON:
      state.rangeSkeleton = action.payload;
      return { ...state };
    case SET_SINGLE_EXPERIENCE_SKELETON:
      state.singleExperienceSkeleton = action.payload;
      return { ...state };
    case SET_SALARY_RANGE_BY_CITIES:
      state.salaryRangeByCities = action.payload;
      return { ...state };
    case SET_SINGLE_CITY_SKELETON:
      state.singleCityLoading = action.payload;
      return { ...state };
    case SET_CITES_RANGE_SKELETON:
      state.citiesRangeSkeleton = action.payload;
      return { ...state };
    case SET_CITIES_LIST:
      state.citiesList = action.payload;
      return { ...state };
    case SET_SALARY_RANGE_SKELETON_BOX:
      state.salaryRangeSkeletonBox = action.payload;
      return { ...state };
    default:
      return state;
  }
}

// This reducer manages the user's location-related data, including state, city, country, state list, top cities, and experience range.
// Each action updates the corresponding piece of state and returns a new state object.
